var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './styles/app.css';
import Main from './layout/Main';
import Header from './components/Header';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from './components/ScrollToTop';
import GlobalFonts from './styles/fonts';
import GlobalReset from './styles/reset';
import 'regenerator-runtime/runtime';
import AuthProvider from './providers/AuthProvider';
import UserContainer from './reducers/authentication';
var App = function () { return (_jsxs("div", __assign({ className: "app" }, { children: [_jsx(GlobalReset, {}), _jsx(GlobalFonts, {}), _jsx(Router, { children: _jsx(AuthProvider, { children: _jsxs(UserContainer.Provider, { children: [_jsx(Header, {}), _jsx(ScrollToTop, {}), _jsx(Main, {})] }) }) }), _jsx(ToastContainer, { position: "bottom-center" })] }))); };
export default App;
